const cache = {};

export const errorPrefix = '[LB:loadScript]';

export default function loadScript(url, resolveAs) {
  if (process.env.NODE_ENV === 'test') return Promise.resolve();

  if (cache[url]) {
    return cache[url];
  }

  cache[url] = new Promise((resolve, reject) => {
    const script = document.createElement('script');

    script.src = url;
    script.onload = resolve;
    script.onerror = event => {
      reject(new Error(`${errorPrefix} Failed to load ${event.target.src}`));
    };

    document.body.appendChild(script);
  }).then(() => window[resolveAs]);

  return cache[url];
}
